import styled from '@emotion/styled'

import { TYPOGRAPHY_36, TYPOGRAPHY_24_400, TYPOGRAPHY_58 } from 'theme/theme'

export const SectionWrapper = styled.div`
  padding-top: ${props => props.hero ? '10px' : '110px'};
  background: linear-gradient(180deg, rgba(196, 196, 196, 0) 14.94%, rgba(196, 196, 196, 0.2) 100%);
`

export const Title = styled.div`
  ${TYPOGRAPHY_58}

  color: #656770;
  font-weight: 700;
  ${props => props.center ? 'text-align: center;' : ''}
  ${props => props.hero ? 'max-width: 50%;' : ''}

  @media (max-width: 767px) {
    text-align: center;
    font-size: 24px;
    line-height: 36px;
    ${props => props.hero ? 'max-width: 90%;' : ''}
  }
`

export const InvestorsWrapper = styled.div`
  max-width: ${props => props.aboutUs ? '1020px' : '705px'};
  flex: 2;
  margin-left: 80px;
  margin-right: 50px;
  justify-content: center;
  display: flex;
  flex-direction: column;

  @media (max-width: 1199px) {
    margin-left: 50px;
  }

  @media (max-width: 767px) {
    align-items: center;
    max-width: 365px;
    margin: 0 auto;
  }
`

export const InvestorsTextsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${props => props.aboutUs ? 'margin-top: 80px;' : ''}
  ${props => props.hero ? 'margin-top: 80px;' : ''}
  ${props => props.hero ? 'margin-bottom: 80px;' : ''}

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
`

export const Text = styled.div`
  ${TYPOGRAPHY_24_400}

  display: flex;
  align-items: center;
  width: 250px;
  color: #7f8289;
  text-align: left;
  padding-left: 20px;
  border-left: 1px solid #0bf;
  margin-top: 50px;
  margin-right: 110px;

  &:last-of-type {
    margin-right: unset;
  }

  @media (max-width: 1199px) {
    margin-right: auto;
  }

  @media (max-width: 767px) {
    width: 100%;
    text-align: center;
    border-left: unset;
    padding-left: unset;

    &:first-of-type {
      flex-direction: column;

      &::before {
        content: '';
        display: flex;
        width: 33%;
        border-bottom: 1px solid #0bf;
        margin-bottom: 20px;
      }
    }
  }
`

export const Sub = styled.div`
  ${TYPOGRAPHY_36}

  color: #a7a8ad;
  ${props => props.center ? 'text-align: center;' : ''}
`

export const ImageWrapper = styled.div`
  display: flex;
  align-items: start;
  max-width: 460px;
  width: 100%;
  margin-left: 50px;
  ${props => props.hero ? 'margin-right: 80px;' : ''}
  flex: 1;

  @media (max-width: 1199px) {
    max-width: 460px;
  }

  @media (max-width: 767px) {
    margin: 0 110px 30px;
  }
`

export const CompaniesWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 80px;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
`
